import React from 'react'
import { Modal } from 'react-bootstrap';

export default function Disclaimer({ showModal, closeModal}) {
  return (
    <Modal show={showModal} centered>
    <Modal.Header className="bg-lightgreen text-white modal-head">
      <Modal.Title className="fw-bold">Disclaimer</Modal.Title>
    </Modal.Header>
    <Modal.Body className="bg-lightgreen text-white">
    FantasyBet is a <strong className='text-orange'>fantasy betting platform</strong> designed for entertainment and educational purposes only. <br/> <br/>
    The platform <strong className='text-orange'>does not offer real-money gambling</strong>. Bets are placed using virtual coins, which have no cash value and cannot be withdrawn or exchanged for money. <br/> <br/>
    Virtual coins may be purchased using real money. However, all betting gains and losses are fictional, and <strong className='text-orange'>no real-money prizes or payouts are offered</strong>.
    </Modal.Body>
    <Modal.Footer className="bg-lightgreen border-top-0 justify-content-center">
        <button className="mt-3 w-100 btn btn-prim text-white fw-bold" onClick={closeModal}>I Acknowledge</button>
    </Modal.Footer>
  </Modal>
  )
}
